import { useEffect, useState } from "react";
import { api, API } from "../lib/api";
import { Landmark } from "lucide-react";

export default function TaxSummaryCard() {
  const [years, setYears] = useState([]);
  useEffect(() => { api.get("/gigs/driver/tax-summary").then((r) => setYears(r.data)).catch(() => {}); }, []);
  if (years.length === 0) return null;
  return (
    <div className="p-5 rounded-2xl bg-[#131722] border border-slate-800" data-testid="tax-summary-card">
      <p className="text-xs font-mono uppercase tracking-widest text-slate-400 flex items-center gap-1.5 mb-2"><Landmark className="w-3.5 h-3.5 text-amber-400" />Earnings summaries</p>
      <ul className="space-y-1.5">
        {years.map((y) => (
          <li key={y.year} className="flex items-center gap-3 text-sm" data-testid={`tax-year-${y.year}`}>
            <span className="font-mono text-slate-200">{y.year}</span>
            <span className="text-xs text-slate-500 flex-1">{y.runs} runs · ${y.net.toFixed(2)} net</span>
            <a href={`${API}/gigs/driver/tax-summary/${y.year}.pdf`} target="_blank" rel="noreferrer" data-testid={`tax-pdf-${y.year}`} className="text-xs text-cyan-300 hover:underline">Download PDF</a>
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-slate-500 mt-2">For your records — not an official tax form.</p>
    </div>
  );
}
